import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import classes from "./PointExchangeResult.module.scss";
import resultChar from "../../static/images/point/result-char.png";
import SimpleButton from "../../atoms/simple-button/SimpleButton";
import { postUserGiftEmailAuthExchange } from "../../api/UserPointHistoryApi";

const PointExchangeResult = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const postGiftEmailAuthExchangeApi = postUserGiftEmailAuthExchange();
  const hasPostedRef = useRef(false);

  const token = searchParams.get("token");
  const giftId = searchParams.get("giftId");
  const pointOwnerIdParam = searchParams.get("pointOwnerId");
  const isAuthExchange = !!token && !!giftId;
  const isProcessing =
    isAuthExchange &&
    postGiftEmailAuthExchangeApi.state?.status !== "success" &&
    postGiftEmailAuthExchangeApi.state?.status !== "error";

  useEffect(() => {
    if (!isAuthExchange || hasPostedRef.current) return;
    hasPostedRef.current = true;

    const pointOwnerId =
      pointOwnerIdParam == null || pointOwnerIdParam.trim() === ""
        ? undefined
        : Number(pointOwnerIdParam);

    postGiftEmailAuthExchangeApi.post({
      token,
      giftId,
      pointOwnerId,
    });
  }, [giftId, isAuthExchange, pointOwnerIdParam, token]);
  
  return (
    <div className={classes.container}>
      <img src={resultChar} alt="ロゴ" className={classes.logo} />
      <h1 className={classes.title}>
        {isProcessing ? "交換受付中..." : "交換受付完了！"}
      </h1>
      {isProcessing ? (
        <>
          <p className={classes.lead}>ごほうび交換を受付しています。</p>
          <div className={classes.spacer}></div>
          <p className={classes.text}>このままお待ちください。</p>
        </>
      ) : (
        <>
          <p  className={classes.lead}>お申込みありがとうございます！</p>
          <div className={classes.spacer}></div>
          <p className={classes.text}>一週間くらいで事務局より</p>
          <p className={classes.text}>登録いただいているメールを送ります。</p>
          <div className={classes.spacer}></div>
          <p className={classes.text}>楽しみにお待ちください！</p>
        </>
      )}
      <div className={classes.buttonArea}>
        <SimpleButton
          label="閉じる"
          width="90%"
          color="gray"
          isRadius={true}
          onClick={() => navigate("/point")}
          disabled={isProcessing}
        />
      </div>
    </div>
  );
};

export default PointExchangeResult;
